import { useEffect, useState } from 'react';
import type { Foto } from '../domain/types';
import { MuellIcon, SchliessenIcon } from '../icons';

interface FotoGalerieProps {
	fotos: Foto[];
	label: string;
	onEntfernen: (fotoId: string) => void;
}

export function FotoGalerie({ fotos, label, onEntfernen }: FotoGalerieProps) {
	const [grossesFotoId, setGrossesFotoId] = useState<string | null>(null);
	const [loeschFotoId, setLoeschFotoId] = useState<string | null>(null);
	const grossesFoto = fotos.find((foto) => foto.id === grossesFotoId);

	useEffect(() => {
		if (grossesFotoId && !grossesFoto) setGrossesFotoId(null);
	}, [grossesFoto, grossesFotoId]);

	if (fotos.length === 0) return null;

	return (
		<>
			<div className="foto-galerie" aria-label={label}>
				{fotos.map((foto, index) => (
					<div key={foto.id} className="foto-kachel">
						<button
							type="button"
							className="foto-vorschau-knopf"
							onClick={() => setGrossesFotoId(foto.id)}
							aria-label={`${label}: Foto ${index + 1} groß anzeigen`}
						>
							<img src={foto.datenUrl} alt="" />
							<span>{new Date(foto.aufgenommenAm).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })}</span>
						</button>
						<button
							type="button"
							className="foto-loeschen-knopf"
							onClick={() => setLoeschFotoId(foto.id)}
							aria-label={`Foto ${index + 1} löschen`}
						>
							<MuellIcon width={14} height={14} />
						</button>
						{loeschFotoId === foto.id && (
							<div className="foto-loeschfrage" role="alert">
								<span>Foto löschen?</span>
								<div>
									<button type="button" onClick={() => setLoeschFotoId(null)}>
										Nein
									</button>
									<button
										type="button"
										className="ist-gefahr"
										onClick={() => {
											onEntfernen(foto.id);
											setLoeschFotoId(null);
										}}
									>
										Ja
									</button>
								</div>
							</div>
						)}
					</div>
				))}
			</div>

			{grossesFoto && (
				<div className="foto-lightbox" role="dialog" aria-modal="true" aria-label={`${label}: Fotoansicht`}>
					<button
						type="button"
						className="foto-lightbox-schliessen"
						onClick={() => setGrossesFotoId(null)}
						aria-label="Fotoansicht schließen"
					>
						<SchliessenIcon width={22} height={22} />
					</button>
					<img src={grossesFoto.datenUrl} alt="" />
					<p>
						Aufgenommen am{' '}
						{new Date(grossesFoto.aufgenommenAm).toLocaleString('de-DE', {
							dateStyle: 'medium',
							timeStyle: 'short'
						})}
					</p>
				</div>
			)}
		</>
	);
}
